import React from "react";
import { Tooltip } from "@mui/material";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import CustomChip from "views/pages/manage/common/customChip/CustomChip";
import { ReactComponent as EyeIcon } from "assets/img/svg/eye.svg";

import { BUPopover } from "views/pages/manage/unAssigned/studentFinanceApproval/epmrCancellation/constant";
import { getFormattedDate } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import { getUpdatedTime, LastUpdatedDetails } from "views/pages/manage/employeeManagement/userProfile/helper";
import { formattedDate, rejectionHandler } from "../shared/utils";
import { getStatusChipInfo } from "../shared/utils";
import DateExtnsionActionMenu from "../components/actions/DateExtnsionActionMenu";

const getChequeColumns = ({
  dropdowns,
  userDetails,
  updateStatus,
  setUpdateStatusInfo,
  onViewSlip,
  isApprovePermission,
  navigateToGivenPath,
  buDescriptionMap,
  setBuDescriptionMap,
  getChequeDateExtensionLogs,
  setShowModelInfo,
  showModelInfo
}) => [
    {
      key: "businessAreaValue",
      label: "BU",
      sortable: true,
      width: 120,
      render: (value) =>
        value ? (
          <Tooltip title={value?.label}>
            <div className="ellipsis-text-container">
              <span>{value?.label}</span>
              <BUPopover
                businessArea={value?.label}
                businessAreaOptions={dropdowns?.businessAreas}
                buDescriptionMap={buDescriptionMap}
                setBuDescriptionMap={setBuDescriptionMap}
              />
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    },

    {
      key: "cashierOffice",
      label: "Cashier Office",
      width: 140,
      sortable: true,
      render: (value, row) =>
        value ? (
          <Tooltip title={value}>
            <div className="ellipsis-text-container">
              <span>{value}</span>
              <BUPopover
                businessArea={row?.cashierOffice}
                businessAreaOptions={dropdowns?.businessAreas}
                buDescriptionMap={buDescriptionMap}
                setBuDescriptionMap={setBuDescriptionMap}
              />
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    },
    {
      key: "psid",
      label: "PSID",
      width: 140,
      sortable: true,
      render: (value, row) =>
        value ? (
          <Tooltip title={value}>
            <div className="ellipsis-text-container">
              <span>{value}</span>
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    },
    {
      key: "studentName",
      label: "Student name",
      width: 140,
      sortable: true,
      render: (value, row) =>
        value ? (
          <Tooltip title={value}>
            <div className="ellipsis-text-container">
              <span>{value}</span>
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    },

    {
      key: "bank",
      label: "Bank Name",
      sortable: true,
      width: 130,
      render: (value) =>
        value ? <Tooltip title={value}><div className="ellipsis-text-container">{value}</div></Tooltip> : <div>-</div>
    },
    {
      key: "referenceNumber",
      label: "Cheque No.",
      sortable: true,
      width: 140,
      render: (value, row) =>
        value ? (
          <Tooltip title={value}>
            <div className="ellipsis-text-container">
              {value}
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    },

    {
      key: "oldChequeDate",
      label: "Old Cheque Date",
      sortable: true,
      width: 140,
      render: (value, row) =>
        value ? (
          <Tooltip title={formattedDate(value)}>
            <div className="ellipsis-text-container">
              {formattedDate(value)}
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    },
    {
      key: "newChequeDate",
      label: "New Cheque Date",
      sortable: true,
      width: 140,
      render: (value, row) =>
        value ? (
          <Tooltip title={formattedDate(value)}>
            <div className="ellipsis-text-container">
              {formattedDate(value)}
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    },
    {
      key: "courseId",
      label: "Course Id",
      sortable: true,
      width: 140,
      render: (value, row) =>
        value ? (
          <Tooltip title={value}>
            <div className="ellipsis-text-container">
              {value}
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    },
    {
      key: "term",
      label: "Term",
      sortable: true,
      width: 140,
      render: (value, row) =>
        value ? (
          <Tooltip title={value}>
            <div className="ellipsis-text-container">
              {value}
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    },
    {
      key: "receiptId",
      label: "Receipt No.",
      sortable: true,
      width: 140,
      render: (value, row) =>
        value ? (
          <Tooltip title={value}>
            <div className="ellipsis-text-container">
              {value}
            </div>
          </Tooltip>
        ) : (
          <div>-</div>
        )
    },

    {
      key: "depositSlipS3Key",
      label: "Attachment",
      width: 80,
      render: (value) =>
        value ? (
          <AButton
            variant="primary_filled"
            size="xs"
            onClick={() => onViewSlip?.(value)}
          >
            View
          </AButton>
        ) : (
          <div>-</div>
        )
    },

    {
      key: "updatedOn",
      label: "Last Updated On",
      sortable: true,
      width: 180,
      render: (value, row) => {
        const display = LastUpdatedDetails(value, row?.updatedBy);
        return value ? <Tooltip title={display}><div>{display}</div></Tooltip> : <div>-</div>;
      }
    },

    {
      key: "updatedOn",
      label: "Approved On",
      width: 180,
      sortable: true,
      render: (value, row) => {
        if (!value || !["approved", "completed",'date_extended'].includes(row?.status?.toLowerCase())) {
          return <div>-</div>;
        }
        const display = `${getFormattedDate(value)} at ${getUpdatedTime(value)}`;
        return <Tooltip title={display}><div>{display}</div></Tooltip>;
      }
    },

    {
      key: "status",
      label: "Request Status",
      width: 180,
      pinned: true,
      render: (_, row) => (
        <CustomChip
          className="text-wrap mt-1 w-100 text-center"
          {...getStatusChipInfo(row)}
        />
      )
    },

    {
      key: "actions",
      label: "Action",
      width: 380,
      pinned: true,
      render: (_, row) => {
        const {
          id,
          approvalStatus,
          status,
          isL1Approver,
          isL2Approver,
          isL3Approver,
          depositSlipNo
        } = row;

        const actionsEnabled =
          (approvalStatus === "L1_PENDING" && isL1Approver) ||
          (approvalStatus === "L2_PENDING" && isL2Approver) ||
          (approvalStatus === "L3_PENDING" && isL3Approver);

        return (
          <div className="d-flex align-items-center">
            {isApprovePermission && (
              <>
                <AButton
                  variant="danger_filled"
                  size="xs"
                  disabled={!actionsEnabled}
                  onClick={() =>
                    rejectionHandler({
                      ...row,
                      setUpdateStatusInfo,
                      status,
                      approvalStatus,
                      approvalAction: "REJECT",
                      isRemarkMandatory: true,
                      isUpdatedDetailRequired: true,
                      depositSlipNo,
                      userDetails,
                       dialogInfo:{
                        remarksMandatory: true
                      }
                    })
                  }
                >
                  Reject
                </AButton>

                <AButton
                  variant="primary_filled"
                  size="xs"
                  disabled={!actionsEnabled}
                  onClick={() =>
                    updateStatus({ id, approvalAction: "APPROVE", ...row, userDetails })
                  }
                >
                  Approve
                </AButton>

                <AButton
                  variant="outline"
                  size="xs"
                  disabled={!actionsEnabled}
                  onClick={() => {
                    const dialogInfo = {
                      heading: "Send back for correction",
                      subHeading: ``,
                      proceedBtn: <button style={{ backgroundColor: '#00B0F5', width: 'fit-content', color: '#FFF', border: 'none' }}>Send back for correction</button>,
                      remarksMandatory: true
                    }
                    rejectionHandler({
                       ...row,
                      setUpdateStatusInfo,
                      status,
                      approvalStatus,
                      approvalAction: "CORRECTION",
                      isRemarkMandatory: true,
                      depositSlipNo,
                      userDetails,
                      dialogInfo,
                      isUpdatedDetailRequired: true
                    })
                  }
                  }
                >
                  Send for Correction
                </AButton>
              </>
            )}

            <DateExtnsionActionMenu
              getChequeDateExtensionLogs={getChequeDateExtensionLogs}
              setShowModelInfo={setShowModelInfo}
              showModelInfo={showModelInfo}
              row={row}
            />
          </div>
        );
      }
    }
  ];

export const chequeColumns = (deps) => getChequeColumns(deps);
